import { Injectable } from '@angular/core';
import { InfracaoTransporteController } from 'app/controllers/mob/infracao-transporte.controller';
import { InfracaoTransporteDTO, InfracaoTransporteDTOList } from 'app/model/dtos/mob/infracao-transporte-dto';

import { ApiService } from '../api-service.interface';
import { LoaderService } from '../loader.service';

@Injectable()
export class InfracaoTransporteService implements ApiService<InfracaoTransporteDTO>{

    constructor(
        private _infracaoTransporteController: InfracaoTransporteController,
        private _loaderService: LoaderService
    ) { }
    
    find(search?: any): Promise<InfracaoTransporteDTO[]> {
        this._loaderService.show();
        return this._infracaoTransporteController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }
    
    findInfracoes(search?: any): Promise<InfracaoTransporteDTO[]> {
        this._loaderService.show();
        return this._infracaoTransporteController.findInfracoes(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    getInfracoes(search?: any): Promise<InfracaoTransporteDTOList> {
        this._loaderService.show();
        return this._infracaoTransporteController.getInfracoes(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<InfracaoTransporteDTO> {
        this._loaderService.show();
        return this._infracaoTransporteController.get(id).finally(() => this._loaderService.hide());
    }

    save(entity: InfracaoTransporteDTO): Promise<InfracaoTransporteDTO> {
        if (!entity.cdInfracao)
            return this.create(entity);
        return this.update(entity);
    }
    
    create(entity: InfracaoTransporteDTO): Promise<InfracaoTransporteDTO> {
        this._loaderService.show();
        return this._infracaoTransporteController.create(entity).finally(() => this._loaderService.hide());
    }
    
    update(entity: InfracaoTransporteDTO): Promise<InfracaoTransporteDTO> {
        this._loaderService.show();
        return this._infracaoTransporteController.update(entity).finally(() => this._loaderService.hide());
    }
}
